import { z } from "zod";
import { ESTADOS_MESA_UI } from "../enums.js";
/** Zonas del salón (ej: "Salón principal", "Terraza"). */
export const ZonaSchema = z.object({
    id: z.string().uuid(),
    nombre: z.string().min(1).max(80),
    orden: z.number().int().nonnegative(),
    activa: z.boolean(),
});
export const CrearZonaSchema = z.object({
    nombre: z.string().min(1).max(80),
    orden: z.number().int().nonnegative().default(0),
});
/** Mesa configurable (sección 6 del diseño). */
export const MesaSchema = z.object({
    id: z.string().uuid(),
    numero: z.number().int().positive(),
    nombre: z.string().max(80).nullable(),
    zonaId: z.string().uuid(),
    capacidad: z.number().int().positive(),
    posX: z.number().int().nullable(),
    posY: z.number().int().nullable(),
    orden: z.number().int().nonnegative(),
    activa: z.boolean(),
});
/** Mesa enriquecida con su estado visual, tal como la consume la pantalla de salón. */
export const MesaConEstadoSchema = MesaSchema.extend({
    zonaNombre: z.string(),
    estado: z.enum(ESTADOS_MESA_UI),
    sesionId: z.string().uuid().nullable(),
    meseraId: z.string().uuid().nullable(),
    meseraNombre: z.string().nullable(),
    personas: z.number().int().nonnegative().nullable(),
    abiertaEn: z.string().datetime().nullable(),
    totalActual: z.number().nonnegative().nullable(),
    qrToken: z.string().optional(),
});
/** Info mínima para generar/imprimir el QR de una mesa (no viaja en el listado general de mesas). */
export const MesaQrInfoSchema = z.object({
    id: z.string().uuid(),
    numero: z.number().int().positive(),
    nombre: z.string().nullable(),
    qrToken: z.string(),
});
/** Crear mesas en lote: desde-hasta con la misma zona y capacidad. */
export const CrearMesasLoteSchema = z
    .object({
    zonaId: z.string().uuid(),
    desde: z.number().int().positive(),
    hasta: z.number().int().positive(),
    capacidad: z.number().int().positive().max(50),
})
    .refine((data) => data.hasta >= data.desde, {
    message: "'hasta' debe ser mayor o igual que 'desde'",
    path: ["hasta"],
})
    .refine((data) => data.hasta - data.desde < 200, {
    message: "No se pueden crear más de 200 mesas en un solo lote",
    path: ["hasta"],
});
export const ActualizarMesaSchema = z.object({
    numero: z.number().int().positive().optional(),
    nombre: z.string().max(80).nullable().optional(),
    zonaId: z.string().uuid().optional(),
    capacidad: z.number().int().positive().max(50).optional(),
    posX: z.number().int().nullable().optional(),
    posY: z.number().int().nullable().optional(),
});
/** Abrir mesa (registrar personas). */
export const AbrirMesaSchema = z.object({
    personas: z.number().int().positive().max(50),
});
/** Editar el número de comensales de una mesa YA abierta (ej. se sumaron más personas). */
export const EditarPersonasMesaSchema = z.object({
    personas: z.number().int().positive().max(50),
});
/** Mover/unir/desbloquear siempre requieren motivo (bitácora obligatoria). */
export const MoverMesaSchema = z.object({
    mesaDestinoId: z.string().uuid(),
    motivo: z.string().min(3).max(240),
});
export const UnirMesaSchema = z.object({
    mesaDestinoId: z.string().uuid(),
    motivo: z.string().min(3).max(240),
});
export const DesbloquearMesaSchema = z.object({
    motivo: z.string().min(3).max(240),
});
export const CancelarMesaSchema = z.object({
    motivo: z.string().min(3, "El motivo debe tener al menos 3 caracteres.").max(240),
});
/** Fila de la bitácora de movimientos de mesa (auditoría: mover/unir/desbloquear/cancelar). */
export const MovimientoMesaSchema = z.object({
    id: z.string(),
    tipo: z.enum(["MOVER", "UNIR", "DESBLOQUEAR", "CANCELAR", "REVERTIR_COBRO"]),
    motivo: z.string(),
    fecha: z.string(),
    usuarioNombre: z.string(),
    mesaOrigenNumero: z.number(),
    mesaDestinoNumero: z.number().nullable(),
});
export const FiltroMovimientosMesaQuerySchema = z.object({
    desde: z.string().optional(),
    hasta: z.string().optional(),
    tipo: z.enum(["MOVER", "UNIR", "DESBLOQUEAR", "CANCELAR", "REVERTIR_COBRO"]).optional(),
    limite: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=mesa.schema.js.map